import { render, staticRenderFns } from "./ModalProductPrice.vue?vue&type=template&id=3cbc39b8&"
import script from "./ModalProductPrice.vue?vue&type=script&lang=js&"
export * from "./ModalProductPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports